import styled from 'styled-components';

export const HomeComponentContainer = styled.div`
  margin: 10px auto;
  width: 93%;
`;
